// src/layouts/AdminLayout.jsx
import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import AdminSidebar from "../Components/Side/AdminSidebar";
import Sidebar from "../Components/Side/Sidebar";
import Topbar from "../Components/Side/Topbar";
import { useAuth } from "../Components/Auth/AuthContext";

const Layout = () => {
    const Auth = useAuth();
    const role = Auth.authState.roles;
    const user = Auth.authState.user;
    const admin = role === "Admin";

    const [sidebarWidth, setSidebarWidth] = useState(256); 

    // Listen for sidebar width changes (from AdminSidebar)
    useEffect(() => {
        const handleSidebarResize = (e) => {
            setSidebarWidth(e.detail);
        };

        window.addEventListener("sidebar-resize", handleSidebarResize);
        return () => window.removeEventListener("sidebar-resize", handleSidebarResize);
    }, []);

    return (
        <div
            className="grid min-h-screen bg-gray-50 transition-all duration-300"
            style={{
                gridTemplateColumns: `${sidebarWidth}px 1fr`,
            }}
        >
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex flex-col overflow-hidden">
                <Topbar />
                <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-20 mt-10">
                    <Outlet context={{ admin, user }} />
                </main>
            </div>
        </div>
    );
};

export default Layout;
